// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { verifyAuthToken } from './sagas';
import PageLoader from '../../components/PageLoader';
import { type Match } from 'react-router-dom';
import { history } from '../../utilities/history';

type Props = {
  verifyAuthToken: (token: string) => void,
  match: Match
};

class VerifyAuth extends Component<Props> {
  componentDidMount() {
    const { token } = this.props.match.params;
    if (token) {
      this.props.verifyAuthToken(token);
    } else {
      history.push('/page_not_found');
    }
  }

  render() {
    return <PageLoader />;
  }
}

// const mapStateToProps = (state) => ({

// })

const mapDispatchToProps = {
  verifyAuthToken
};

export default connect(
  null,
  mapDispatchToProps
)(VerifyAuth);
